import { Menu } from "../../models/menu"
import { Project } from "../../models/project"
import {
    ClassifierConfigDto,
    ClassifierLanguage,
    ClassifierStatus,
    ClassifierType,
    DatasetFilterKind,
    TypeForTraining
} from "../../models/classifier"
import { ChannelScenario, Scenario, ScenarioBlockType } from "../../models/scenario"
import { ConditionType, SlotSpecialValue } from "../../models/scenarioCondition"
import { Article, ArticleKind, ArticleStatusType } from "../../models/article"
import { KnowledgeBaseAccessType, KnowledgeBasePermittedAction } from "../../models/knowledgeBase/permission"
import type { TreeData } from "@atlaskit/tree"
import { permissionWeightMapper, ROOT_CATEGORY_CODE } from "../../utility/knowledgeBase/knowledgeBase"
import { GetSlotPageResponse, SlotKind, SlotType, SystemSlot } from "../../models/slot"
import { AllowedActionDto, QueueCategory } from "../../models/queueCategory"
import { AgentType } from "../../models/agent"
import { mockedMessage, mockedMessages, mockedQueue, mockedSurveyForm } from "../../utility/tests/mockedObjects"
import { ApiMessage, GetUpdatedMessagesResponse, MessageDirection } from "../../models/Dialogs/message"
import { SurveyForm } from "../../models/Dialogs/surveyForm"
import { Dialog, DialogPerson } from "../../models/Dialogs/dialog"
import { ChannelTypeString } from "../../models/channel"
import { KnowledgeBaseArticlePublishType } from "../../models/knowledgeBase/knowledgeBasePublish"

export const MainMenu: Menu = {
    id: "123",
    title: "sidebar:menu-header",
    items: [
        {
            id: "dialogs",
            title: "sidebar:menu-item-dialog-processing",
            submenus: []
        },
        {
            id: "dialogs-search",
            title: "sidebar:menu-item-dialog-history",
            submenus: []
        },
        {
            id: "monitoring",
            title: "sidebar:menu-item-monitoring",
            submenus: []
        },
        { id: "queues", title: "sidebar:menu-item-queues", submenus: [] }
    ]
}

export const ProjectData: Project[] = [
    {
        id: "eeff",
        name: "Газпром Банк",
        language: "ru",
        logo: process.env.PUBLIC_URL + "/logo512.png"
    },
    {
        id: "gghh",
        name: "Почта России",
        language: "ru",
        logo: process.env.PUBLIC_URL + "/logo512.png"
    },
    { id: "ttyy", name: "Эвотор", language: "en", logo: "" }
]

export const ClassifierConfigurationData: ClassifierConfigDto[] = [
    {
        ProjectId: "test",
        ClassifierConfigId: "test",
        ClassifierId: "test",
        Url: "http://localhost:8085",
        Name: "test",
        Language: ClassifierLanguage.English,
        Type: ClassifierType.WMD,
        Status: ClassifierStatus.Active,
        Active: true,
        TypesForTraining: [],
        UseSpellCorrection: true,
        DoSynonymousAugmentation: false,
        SynonymousAugmentationSlots: [],
        SlotThreshold: 0,
        PlusStopWords: ["стоп-слово 1", "стоп-слово 2"],
        MinusStopWords: ["стоп-слово 3"],
        DatasetFilters: [
            {
                ElasticType: TypeForTraining.IntentType,
                FilterKind: DatasetFilterKind.ByFieldValue,
                Fields: [
                    { FieldName: "tags", Value: "tag1", Compare: "Fnmatch" },
                    { FieldName: "tags", Value: "tag2", Compare: "Ne" },
                    { FieldName: "record_type", Value: "id1", Compare: "Fnmatch" },
                    { FieldName: "record_type", Value: "id2", Compare: "Ne" },
                    { FieldName: "record_type", Value: "id3", Compare: "Ne" },
                    { FieldName: "status", Value: ArticleStatusType.Draft },
                    { FieldName: "status", Value: ArticleStatusType.Approval }
                ]
            }
        ],
        PreprocessorBuilder: "default",
        ChangedAt: "2018-12-04T13:53:42.6785734+07:00",
        Version: "0"
    }
]

export const ScenarioData: Scenario = {
    Blocks: [
        {
            Id: "block_35fe077",
            Position: {
                Left: 0,
                Top: 0
            },
            Inputs: [],
            Outputs: [
                {
                    Id: "block_35fe077",
                    Type: "Article",
                    To: "block_4ebfc45"
                }
            ],
            Type: ScenarioBlockType.Start
        },
        {
            Id: "block_4ebfc45",
            Position: {
                Left: 300,
                Top: 0
            },
            Inputs: [
                {
                    From: "block_35fe077",
                    FromOutput: {
                        Id: "block_35fe077",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [
                {
                    Id: "block_4ebfc45_btn_0",
                    Type: "Article",
                    To: "block_19c1daa"
                },
                {
                    Id: "block_4ebfc45_btn_1",
                    Type: "Article",
                    To: "block_46f11ed"
                }
            ],
            Type: ScenarioBlockType.Message,
            BlockData: {
                Message: {
                    Text: "",
                    Buttons: [
                        {
                            Id: "block_4ebfc45_btn_0",
                            Title: "",
                            Type: "Article",
                            Payload: "block_19c1daa"
                        },
                        {
                            Id: "block_4ebfc45_btn_1",
                            Title: "",
                            Type: "Article",
                            Payload: "block_46f11ed"
                        }
                    ]
                }
            }
        },
        {
            Id: "block_19c1daa",
            Position: {
                Left: 800,
                Top: 0
            },
            Inputs: [
                {
                    From: "block_4ebfc45",
                    FromOutput: {
                        Id: "block_4ebfc45_btn_0",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [
                {
                    Id: "condition_2abd889",
                    Type: "Article",
                    To: "block_5400f7c"
                }
            ],
            Type: ScenarioBlockType.Form,
            BlockData: {
                Form: {
                    FormSlots: {
                        Slots: [
                            {
                                SlotId: "sys_firstname",
                                IsMandatory: false
                            },
                            {
                                SlotId: "sys_contract",
                                IsMandatory: true
                            }
                        ]
                    },
                    OutputConditions: {
                        Conditions: [
                            {
                                Id: "condition_2abd889",
                                And: [
                                    {
                                        Slot: "sys_firstname",
                                        Condition: ConditionType.Greater,
                                        Value: "0"
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        },
        {
            Id: "block_46f11ed",
            Position: {
                Left: 350,
                Top: 300
            },
            Inputs: [
                {
                    From: "block_4ebfc45",
                    FromOutput: {
                        Id: "block_4ebfc45_btn_1",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [
                {
                    Id: "condition_2d6ee57",
                    Type: "Article",
                    To: "block_97ded8"
                }
            ],
            Type: ScenarioBlockType.Condition,
            BlockData: {
                Condition: {
                    Conditions: [
                        {
                            Id: "condition_2d6ee57",
                            And: [
                                {
                                    Slot: "sys_contract",
                                    Condition: ConditionType.Equal,
                                    Value: "Name"
                                },
                                {
                                    Slot: SlotSpecialValue.ArbitraryExpression,
                                    Value: "{{slot_id}} = 5"
                                },
                                {
                                    Slot: "sys_contract",
                                    Condition: ConditionType.Greater,
                                    Value: "1"
                                },
                                {
                                    Slot: SlotSpecialValue.AllMandatoryFilledIn
                                }
                            ]
                        },
                        {
                            Id: "condition_d6812d",
                            And: [
                                {
                                    Slot: "sys_email",
                                    Condition: ConditionType.Equal,
                                    Value: "aaaa@mail.com"
                                }
                            ]
                        }
                    ]
                }
            }
        },
        {
            Id: "block_97ded8",
            Position: {
                Left: 741,
                Top: 414
            },
            Inputs: [
                {
                    From: "block_46f11ed",
                    FromOutput: {
                        Id: "condition_2d6ee57",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [],
            Type: ScenarioBlockType.Article,
            BlockData: {
                Article: {
                    ArticleId: "61db2b80-7e7b-42d4-a821-9ebf65ed207a",
                    ArticleTitle: "Name"
                }
            }
        },
        {
            Id: "block_5400f7c",
            Position: {
                Left: 1300,
                Top: 0
            },
            Inputs: [
                {
                    From: "block_19c1daa",
                    FromOutput: {
                        Id: "condition_2abd889",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [],
            Type: ScenarioBlockType.Message,
            BlockData: {
                Message: {
                    Text: "",
                    Buttons: []
                }
            }
        },
        {
            Id: "block_4e577c4",
            Position: {
                Left: 1175,
                Top: 305
            },
            Inputs: [
                {
                    From: "block_19c1daa",
                    FromOutput: {
                        Id: "condition_2abd889",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [
                {
                    Id: "block_4e577c4_output_message_a",
                    Type: "Article",
                    To: "block_1ea7bbc"
                }
            ],
            Type: ScenarioBlockType.Agent,
            BlockData: {
                Agent: {
                    AgentId: "abab",
                    AgentType: AgentType.ABAgent,
                    OwnedByThisScenario: true
                }
            }
        },
        {
            Id: "block_1ea7bbc",
            Position: {
                Left: 1535,
                Top: 208
            },
            Inputs: [
                {
                    From: "block_4e577c4",
                    FromOutput: {
                        Id: "block_4e577c4_output_message_a",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [],
            Type: ScenarioBlockType.Agent,
            BlockData: {
                Agent: {
                    AgentId: "aiasssist2",
                    AgentType: AgentType.AIAssist2,
                    OwnedByThisScenario: false
                }
            }
        },
        {
            Id: "block_4d8db3d",
            Type: ScenarioBlockType.Command,
            Position: {
                Left: 1530,
                Top: 468
            },
            Inputs: [
                {
                    From: "block_4e577c4",
                    FromOutput: {
                        Id: "block_4e577c4_output_message_a",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [],
            BlockData: {
                Command: {
                    Text: "SET_SLOT_VALUE_slot_id текст"
                }
            }
        }
    ]
}

export const getScenarioArticleData = (ProjectId: string, SymbolCode: string): Article => ({
    Id: "id",
    Title: "Test",
    ProjectId: "test",
    SymbolCode: SymbolCode,
    Status: ArticleStatusType.Draft,
    Scenario: ScenarioData,
    Expire: 0,
    PrevVersion: 0,
    FirstVersion: 0,
    ModifiedDate: 0,
    ModifiedUserLogin: "",
    Type: "",
    Kind: ArticleKind.Scenario,
    Tags: [],
    Parameters: [],
    Permissions: [
        {
            Action: KnowledgeBasePermittedAction.Edit,
            ProjectId,
            SearchValue: "",
            Type: KnowledgeBaseAccessType.All,
            Value: "test",
            Weight: permissionWeightMapper(KnowledgeBaseAccessType.All, KnowledgeBasePermittedAction.Edit)
        }
    ],
    PermissionsWithNested: false,
    Expanded: false,
    PublishInfo: {
        Type: KnowledgeBaseArticlePublishType.Default,
        PublishDate: 0,
        UnpublishDate: 0,
        IsCompleted: false
    }
})

export const ChannelScenarioData: ChannelScenario = {
    Blocks: [
        {
            Id: "block_35fe077",
            Position: {
                Left: 20,
                Top: 0
            },
            Inputs: [],
            Outputs: [
                {
                    Id: "block_35fe077",
                    Type: "Article",
                    To: "block_2e750d9"
                }
            ],
            Type: ScenarioBlockType.Channel,
            BlockData: {
                Channel: {
                    ChannelId: "channel_40b3f1c",
                    ChannelType: "odnoklassniki"
                }
            }
        },
        {
            Id: "block_2e750d9",
            Position: {
                Left: 520,
                Top: 0
            },
            Inputs: [
                {
                    From: "block_35fe077",
                    FromOutput: {
                        Id: "block_35fe077",
                        Type: "Article"
                    }
                }
            ],
            Outputs: [],
            Type: ScenarioBlockType.Article,
            BlockData: {
                Article: {
                    ArticleId: "62d4060e-6bf3-45bc-80a1-5a2ba1128064",
                    ArticleTitle: "Name"
                }
            }
        }
    ]
}

export const MarkedMessagesData = {
    data: [
        {
            id: "fdaa4d16-4ed0-4d49-a188-54cecef3ebf6",
            text: "Тема: Добро пожаловать в Почту Mail.ru\nДобро пожаловать!\n&#160;\nРады видеть вас в&#160;Почте.\nРассказываем о&#160;её&#160;главных возможностях.\n&#160;\nВсе, что нужно от&#160;почты\nПодключайте несколько аккаунтов, пишите и&#160;получайте письма, отправляйте тяжелые файлы.\n\nМобильные приложения\nПомогут оставаться на&#160;связи в&#160;любой точке мира.\nGooglePlay: https://trk.mail.ru/c/iuikp0?mt_gaid={$gaid}\nAppStore: https://trk.mail.ru/c/ru3qx0?mt_idfa={$idfa}\n&#160;&#160;\nОплата услуг\nЖКХ, налоги, интернет и&#160;другие услуги можно оплатить, не&#160;выходя из&#160;аккаунта.\nПопробовать: https://e.mail.ru/payment/center\n&#160;\nТемная тема и&#160;новые фоны\nПочта красивая и&#160;удобная в&#160;любое время суток.\nВыбрать тему: https://e.mail.ru/inbox/?themes\n&#160;\nУмная сортировка\nПочта скрывает рассылки, сортируя их&#160;на&#160;две категории: социальные сети и&#160;другие рассылки.\nВключить сортировку: https://e.mail.ru/inbox?metathreads=on\n&#160;&#160;\nУмные ответы\nВыберите готовый ответ, чтобы отреагировать на&#160;письмо двумя кликами.\n\n\n---\nС любовью, команда Почты Mail‌.ru\n&#160;\nСледите за&#160;нашими новостями в&#160;блоге Почты: https://blog.mail.ru/ и&#160;социальных сетях: \nhttps://vk.com/e_mail_ru\nhttps://ok.ru/emailru\nhttps://www.facebook.com/why.mail.ru\nhttps://twitter.com/e_mail_ru&#160;\n\nCopyright 2021 Mail‌.ru Group, Москва&#160;— Все права защищены.\n\nВы&#160;получили это письмо, потому что являетесь пользователем Сервиса Почта Mail‌.ru на&#160;основании Пользовательского соглашения: https://help.mail.ru/legal/terms/mail/ua\n\t&#160;\nОтписаться: https://e.mail.ru/mailer/subscriptions?unsubscribe_jwt_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsZXR0ZXJfaWQiOjU3MDQsInRlc3RpbmciOjAsInBvc3RfdHlwZSI6IkMiLCJlbWFpbCI6ImNyYWZ0dGFsazRAYmsucnUiLCJwb3N0X2lkIjo0Miwic2VuZF91dWlkIjoiNmQyNmI2ZmMtMWYxOS00NTc2LWFiZTQtNGU2NWFlY2RjZTIyIiwibGFuZ3VhZ2UiOiJydSJ9.OzwdYm1YcFbrXnW-CSZqKvSGxUzJcnaAf5YQcntIyxY\n\nСлужба поддержки: https://help.mail.ru/mail",
            timestamp: 1619020523445
        },
        {
            id: "e3cca197-9c76-4997-aa45-f07fac745311",
            text: "Тема: Неправомерный отказ по кредиту\nЗдравствуйте, мною -Шатровым А.Г. 05.09.2020 г. на основании &#160;Постановление Правительства РФ от 26 ноября 2019 г. № 1514 “Об утверждении Правил предоставления субсидий из федерального бюджета российским кредитным организациям на возмещение недополученных доходов по выданным потребительским кредитам (займам), предоставленным гражданам Российской Федерации, проживающим на сельских территориях (сельских агломерациях), на повышение уровня благоустройства домовладений”, были поданы документы в Челябинский региональный филиал АО &#171;Россельхозбанк&#187; офис №3349/78/18 с. Шатрово, для оформления льготного потребительского кредита, на цели согласно указанного постановления, а также с порядком указанным на сайте АО &#171;Россельхозбанк&#187; . Менеджером Репиной А.С. были направлены замечания на внесения изменений в договор о подключении (технологическом) присоединении объектов капитального строительства к сети газораспределения, по следующим пунктам:&#160;\n1. &#171;Договор должен быть подписан в дату выдачи кредита, а не 6 ноября&#187;. Мне не понятно, каким образом, данное замечание может быть исполнено? Как я могу заранее &#160;знать дату оформления кредита или договор о подключении должен быть с открытой датой !?;\n2. &#171;Не указан кадастровый номер объекта&#187; Кадастровый номер какого объекта, ОКСа или земельного участка? В договоре о подключении указан адрес земельного участка!;\n3. &#171;Не указаны даты начала и окончания работ&#187;. В пп.3 п.I договора подключения &#160;указаны примерные сроки выполнения всех мероприятий, согласно статистики выполняемых работ предприятия, а также естественных природных условий региона подключения!;\n4. &#171;Оплату не проводим частями, это только по ипотечным кредитам&#187;. В договоре подключения указан порядок оплаты работ заявителем на подключения, а не банка. Естественно, что нужно разовое перечисление средств от банка на счет подрядной организации.&#160;\nВ связи с этим прошу проверить правомерность и доводы специалиста &#160;по указанным замечаниям, а в случае согласия с ним, разъяснить мне их с описанием регламента и норм на основании которых они приняты.\nТакже хочу добавить, что на сегодняшний день являюсь постоянным клиентом АО &#171;Россельхозбанк&#187;, и надеюсь на наше дальнейшее совместное сотрудничество. Договор на подключение и замечания специалиста прилагаю.\nСпасибо. Контактные данные: Адрес эл.почты- shatrovdmitry@mail.ru ; телефон: 8-919-574-52-05\n&#160;\n&#160;\n--\nШатров А.Г.\n&#160;\n&#160;\n--\nКирилл Рудановский",
            timestamp: 1608981429672
        }
    ],
    draw: 1,
    recordsFiltered: 2,
    recordsTotal: 2
}

export const treeWithTwoBranches: TreeData = {
    rootId: "1",
    items: {
        "1": {
            id: "1",
            children: ["1-1", "1-2"],
            hasChildren: true,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "root",
                symbolCode: ROOT_CATEGORY_CODE
            }
        },
        "1-1": {
            id: "1-1",
            children: ["1-1-1", "1-1-2"],
            hasChildren: true,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "First parent",
                symbolCode: "1-1"
            }
        },
        "1-2": {
            id: "1-2",
            children: ["1-2-1", "1-2-2"],
            hasChildren: true,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "Second parent"
            }
        },
        "1-1-1": {
            id: "1-1-1",
            children: [],
            hasChildren: false,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "Child one"
            }
        },
        "1-1-2": {
            id: "1-1-2",
            children: [],
            hasChildren: false,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "Child two"
            }
        },
        "1-2-1": {
            id: "1-2-1",
            children: [],
            hasChildren: false,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "Child three"
            }
        },
        "1-2-2": {
            id: "1-2-2",
            children: [],
            hasChildren: false,
            isExpanded: false,
            isChildrenLoading: false,
            data: {
                title: "Child four"
            }
        }
    }
}

const slot = {
    Id: "0c42e845-e17c-4447-8d82-585b92133681",
    ExternalId: "test-slot",
    ProjectId: "test",
    Title: "Test slot",
    Type: SlotType.Dictionary,
    Kind: SlotKind.Default,
    Question: {
        Text: "Укажите поле №2"
    },
    FailedValidationQuestion: {
        Text: "Не совсем вас понял, повторите ввод"
    },
    ModifiedData: 1643792476000,
    ModifiedUserLogin: "test",
    Prefill: true,
    SkipClassification: false,
    DontShowButtons: false,
    ShowCancelButton: false,
    Permanent: false
}

export const SlotPageData: GetSlotPageResponse = {
    Items: [slot],
    ItemsTotal: 1,
    PageSize: 1,
    PageFrom: 0,
    PageTotal: 1,
    Filtered: 1
}

export const FakeQueueCategories: QueueCategory[] = [
    {
        Queues: [mockedQueue],
        Id: "test_category_0",
        Name: "Test Category",
        Access: [
            {
                Id: "test_category_access_0",
                Type: KnowledgeBaseAccessType.All,
                Action: AllowedActionDto.Modify,
                ProjectId: "test"
            }
        ]
    },
    {
        Queues: [
            {
                ...mockedQueue,
                Id: "74623784",
                Name: "666"
            }
        ],
        Id: "test_category_1",
        Name: "Another Test Category",
        Access: [
            {
                Id: "test_category_access_0",
                Type: KnowledgeBaseAccessType.All,
                Action: AllowedActionDto.Modify,
                ProjectId: "test"
            }
        ]
    }
]

export const fakeDialogMessages: GetUpdatedMessagesResponse = {
    Messages: [
        ...mockedMessages,
        {
            ...mockedMessage,
            Id: "uurtt22",
            Direction: MessageDirection.Incoming,
            Text: "Text 2 images and 2 docs from bot",
            Attachments: [
                {
                    Url: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Lesser_panda_standing.jpg/300px-Lesser_panda_standing.jpg",
                    ContentType: "",
                    Name: "Red panda"
                },
                {
                    Url: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Procyon_lotor_7_-_am_Wasser.jpg/300px-Procyon_lotor_7_-_am_Wasser.jpg",
                    ContentType: "",
                    Name: "Raccoon"
                },
                {
                    Url: "https://www.google.com/robots.txt",
                    ContentType: "",
                    Name: "robots.txt"
                },
                {
                    Url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
                    ContentType: "",
                    Name: "dummy.pdf"
                }
            ]
        },
        {
            ...mockedMessage,
            Id: "ksdjkwye",
            Direction: MessageDirection.Incoming,
            Text: "Reply with actions from bot",
            Actions: [
                {
                    action_id: "natural_contacts",
                    action_text: "Contacts"
                },
                {
                    action_id: "natural_currency-rates",
                    action_text: "Currency rates"
                }
            ]
        },
        {
            ...mockedMessage,
            Id: "mnsdasmaskdt",
            Attachments: [
                {
                    Url: "https://pngimg.com/uploads/land_rover/land_rover_PNG57.png",
                    ContentType: "image",
                    Name: "land rover 1"
                },
                {
                    Url: "https://pngimg.com/uploads/rat_mouse/rat_mouse_PNG23548.png",
                    ContentType: "image",
                    Name: "land rover 2"
                },
                {
                    Url: "https://cloud-stage.craft-talk.com/api/dialogs/get_file/file/0372/20d6b937-0ccb-450a-888a-0e1bbdf5e9bb-20acff6e-d9f8-4d3a-b724-db72c6b41cb2.docx",
                    ContentType: "application/msword",
                    Name: "document 1"
                }
            ]
        }
    ].map(m => ({ Case: "Message", Fields: m } as ApiMessage)),
    HasMore: false
}

export const fakeDialogPerson: DialogPerson = {
    IdInChannel: "e77a56dc-4bf6-4978-aedc-m5271ae14108",
    OmniUserId: "9cd15c08-1618-3f42-95d5-7b3d051eaed4",
    Firstname: "Firstname",
    Lastname: "Lastname"
}

export const fakeClientSurvey: SurveyForm = mockedSurveyForm

export const fakeDialogs: { [key: string]: Dialog } = {
    "test-dialog-1": {
        Id: "test-dialog-1",
        Client: {
            OmniUserId: "112",
            IdInChannel: "111",
            Firstname: "Viktor",
            Lastname: "Viktor"
        },
        Operator: {
            IdInChannel: "e77a56dc-4bf6-4978-aedc-m5271ae14108",
            OmniUserId: "9cd15c08-1618-3f42-95d5-7b3d051eaed4",
            Firstname: "Op1",
            Lastname: "Op2"
        },
        Channel: {
            Id: "333",
            Type: ChannelTypeString.Telegram,
            Title: "Telegram Channel 1"
        },
        Agent: {
            Id: "444",
            Name: "AiAssist"
        },
        Project: {
            Id: "test",
            Title: "Test project"
        },
        Stat: {
            Dispatched: 1688971377642
        },
        SlotContext: {
            FilledSlots: [
                {
                    Id: SystemSlot.FirstName,
                    Value: "Ivan"
                },
                {
                    Id: SystemSlot.LastName,
                    Value: "Ivanov"
                },
                {
                    Id: SystemSlot.MiddleName,
                    Value: ""
                },
                {
                    Id: "sys_contract",
                    Value: ""
                },
                {
                    Id: "sys_birthdate",
                    Value: ""
                },
                {
                    Id: "sys_email",
                    Value: ""
                },
                {
                    Id: "sys_phone",
                    Value: ""
                },
                {
                    Id: "sys_omniuserid",
                    Value: "5a06c6e7-ed1c-49c5-b0e7-9d5c6e6d406a"
                },
                {
                    Id: "sys_extuserid",
                    Value: ""
                }
            ]
        }
    },
    "test-dialog-2": {
        Id: "test-dialog-2",
        Client: {
            OmniUserId: "117",
            IdInChannel: "839",
            Firstname: "Viktor",
            Lastname: "Zakharov"
        },
        Operator: {
            IdInChannel: "e77a56dc-4bf6-4978-aedc-m5271ae14108",
            OmniUserId: "9cd15c08-1618-3f42-95d5-7b3d051eaed4",
            Firstname: "Turkish",
            Lastname: "Spanish"
        },
        Channel: {
            Id: "webchat-4",
            Type: ChannelTypeString.WebChat,
            Title: "Website widget"
        },
        Agent: {
            Id: "6657",
            Name: "RoutingAgent"
        },
        Project: {
            Id: "test1",
            Title: "New store"
        },
        Stat: {
            Dispatched: 1688971377642
        },
        SlotContext: {
            FilledSlots: [
                {
                    Id: "sys_firstname",
                    Value: "Viktor"
                },
                {
                    Id: "sys_lastname",
                    Value: "Zakharov"
                },
                {
                    Id: "sys_middlename",
                    Value: ""
                },
                {
                    Id: "sys_contract",
                    Value: ""
                }
            ]
        }
    },
    "test-dialog-3": {
        Id: "test-dialog-3",
        Client: {
            OmniUserId: "4777",
            IdInChannel: "900",
            Firstname: "John",
            Lastname: "Roat"
        },
        Operator: {
            IdInChannel: "e77a56dc-4bf6-4978-aedc-m5271ae14108",
            OmniUserId: "9cd15c08-1618-3f42-95d5-7b3d051eaed4",
            Firstname: "Support",
            Lastname: "Operator"
        },
        Channel: {
            Id: "facebook-6",
            Type: ChannelTypeString.Facebook,
            Title: "Real estate"
        },
        Agent: {
            Id: "364475",
            Name: "RoutingAgent"
        },
        Project: {
            Id: "test",
            Title: "Test project"
        },
        Stat: {
            Dispatched: 1688971377642
        },
        SlotContext: {
            FilledSlots: [
                {
                    Id: "sys_firstname",
                    Value: "John"
                },
                {
                    Id: "sys_lastname",
                    Value: "Roat"
                },
                {
                    Id: "sys_middlename",
                    Value: ""
                }
            ]
        }
    }
}
